module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/events.json
// module id = 309
// module chunks = 44713349584700